import { motion } from "framer-motion";
import { ArrowRight, ShieldCheck, BadgeEuro, Lock } from "lucide-react";
import { IMAGES } from "@/lib/config";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { delay: i * 0.12, duration: 0.6, ease: "easeOut" } }),
};

const badges = [
  { icon: Lock, text: "Data Blindata in contratto" },
  { icon: BadgeEuro, text: "Prezzo definitivo" },
  { icon: ShieldCheck, text: "Garanzie scritte" },
];

export default function Hero() {
  return (
    <section id="top" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Interno ristrutturato" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-brand-ink/80" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-ink via-brand-ink/80 to-brand-ink/30" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-32 pb-20 w-full">
        <div className="max-w-3xl">
          <motion.span
            variants={fadeUp} initial="hidden" animate="show" custom={0}
            className="inline-block text-brand-gold font-semibold tracking-[0.2em] uppercase text-sm mb-6"
          >
            Gli specialisti delle ristrutturazioni residenziali
          </motion.span>

          <motion.h1
            variants={fadeUp} initial="hidden" animate="show" custom={1}
            className="font-display text-white text-4xl md:text-6xl font-extrabold leading-[1.05] mb-6"
          >
            Sai già il giorno in cui <span className="text-brand-gold">rientri a casa e quanto pagherai veramente.</span>
          </motion.h1>

          <motion.p
            variants={fadeUp} initial="hidden" animate="show" custom={1.5}
            className="font-display text-brand-gold text-xl md:text-2xl font-bold mb-6"
          >
            Te lo scriviamo in contratto prima di iniziare, senza sorprese.
          </motion.p>

          <motion.p
            variants={fadeUp} initial="hidden" animate="show" custom={2}
            className="text-white/85 text-lg md:text-xl leading-relaxed mb-10 max-w-2xl"
          >
            È la nostra <strong className="text-white">Data Blindata</strong>: la fissiamo dopo il sopralluogo,
            la firmiamo insieme e non si sposta. Se ritardiamo per causa nostra, ogni giorno di ritardo te lo paghiamo noi.
          </motion.p>

          <motion.div
            variants={fadeUp} initial="hidden" animate="show" custom={3}
            className="flex flex-col sm:flex-row gap-4 mb-14"
          >
            <a
              href="#preventivo"
              data-testid="hero-quote-btn"
              className="group inline-flex items-center justify-center gap-2 bg-brand-gold hover:bg-brand-goldDark text-brand-ink font-bold px-8 py-4 rounded-full transition-colors"
            >
              Calcola il preventivo online
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#contatti"
              data-testid="hero-contact-btn"
              className="inline-flex items-center justify-center gap-2 border border-white/30 hover:border-white text-white font-semibold px-8 py-4 rounded-full transition-colors"
            >
              Richiedi consulenza gratuita
            </a>
          </motion.div>

          <motion.div
            variants={fadeUp} initial="hidden" animate="show" custom={4}
            className="flex flex-wrap gap-6"
          >
            {badges.map((b) => (
              <div key={b.text} className="flex items-center gap-2.5 text-white/90">
                <b.icon size={20} className="text-brand-sage" />
                <span className="font-semibold text-sm">{b.text}</span>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
